/**
 * reachSubscribe — Substack subscribe-button block.
 *
 * Renders in-editor as a styled placeholder card. Substack serializer
 * replaces it with `[subscribe]` (Substack's token for an inline subscribe
 * widget). LinkedIn / IG / X serializers strip it.
 *
 * HTML on the wire: <div data-reach-subscribe="1"></div>. The data attribute
 * is the round-trip marker so the serializer can recognise it server-side
 * too (the PHP twin reads the same attribute).
 */
import { Node, mergeAttributes } from '@tiptap/core';

export const ReachSubscribe = Node.create({
    name: 'reachSubscribe',

    group: 'block',
    atom: true,            // single unit — can't have inner content selected
    selectable: true,
    draggable: false,

    parseHTML() {
        return [
            { tag: 'div[data-reach-subscribe]' },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                'data-reach-subscribe': '1',
                class: 'adm-editor__block-subscribe',
            }),
            // Visual placeholder content. Serializers never read this — they
            // act on the marker attribute. Editors see the placeholder while
            // composing so they know what the block represents.
            ['span', { class: 'adm-editor__block-label' }, 'Subscribe button'],
            ['span', { class: 'adm-editor__block-hint' }, 'Substack only'],
        ];
    },

    addCommands() {
        return {
            insertReachSubscribe: () => ({ commands }) => commands.insertContent({ type: this.name }),
        };
    },
});
